import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom';
import Client from 'containers/app/client';
import { PrivateRoute } from 'components/routes';
import Routes from './routes';

const NoMatch = () => <div>Not Found</div>;

const FirebaseAnalytics = () => {
  let location = useLocation();
  useEffect(() => {
    const split = location.pathname.split('/');
    const page_name = split[split.length - 1];
    const page_title = location.pathname + location.search;
    console.log('FirebaseAnalytics', location.pathname);
    console.log('FirebaseAnalytics', location.search);

    Client.analytics.setCurrentScreen(page_title);
    Client.analytics.logEvent('page_view', { page_name, page_title });
  }, [location]);
  return null;
};

const Router = () => (
  <BrowserRouter>
    <Switch>
      {Routes.map((route, i) => {
        if (route.public) return <Route key={i} {...route} />;
        return <PrivateRoute key={i} auth={Client.auth} {...route} />;
      })}
      <Route component={NoMatch} />
    </Switch>
    <FirebaseAnalytics />
  </BrowserRouter>
);

export default Router;
